module.exports = __webpack_public_path__ + "img/gg.svg";